<template>
  <HeaderPages />
  <section class="section_header_full_pages">
    <div class="waves_full_pages"></div>
    <div class="box_img_brand_project">
      <img
        src="@/assets/project/Vatamanuk/Vatamanuk.png"
        class="img_brand_project"
        alt="Vatamanuk"
      />
    </div>
    <div class="container_text_full_pages">
      <h1 class="title_home">
        <span class="title_home_4"
          >Корпоративный<br />
          сайт
        </span>
      </h1>
      <div class="box_button_brifing_full_pages">
        <div class="box_button_v2">
          <button class="button_v1" data-action="toggleBig">
            Оставить заявку
          </button>
        </div>
      </div>
    </div>
  </section>
  <section class="section_main_info_project">
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="font_2_4_700_Kreadon">2023</p>
      </div>
      <div class="box_main_info_project_right">
        <p class="font_2_4_700_Kreadon">«Ватаманюк & Партнеры»</p>
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">
          UX/UI дизайн <BR />
          &nbsp;
          <BR />
          Backend <BR />
          &nbsp;
          <BR />
          Frontend
          <BR />
          &nbsp;
          <BR />
          DevOps
        </p>
      </div>
      <div class="box_main_info_project_right">
        <p class="subtext_services_design">
          Юридическая компания «Ватаманюк & Партнеры»
        </p>
      </div>
    </div>
    <!-- <div class="container_main_info_project">
        <div class="box_main_info_project_left"></div>
        <div class="box_main_info_project_right">
          <a target="_blank" href="https://yycare.life/" class="button_light"
            >Сайт</a
          >
        </div>
      </div> -->
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Цели</p>
      </div>
      <div class="box_main_info_project_right">
        <p class="subtext_services_design">
          Создать современный и представительный сайт юридической компании,
          который подчеркнет экспертность и статус фирмы, а также предоставит
          пользователям удобный доступ к ключевой информации. Основные задачи:
          <BR />
          &nbsp;
          <BR />
          Презентация компании, её услуг и портфолио
          <BR />
          &nbsp;
          <BR />
          Отображение команды специалистов с возможностью детального знакомства
          с их опытом
          <BR />
          &nbsp;
          <BR />
          Интерактивные анимации для повышения вовлеченности посетителей
          <BR />
          &nbsp;
          <BR />
          Раздел новостей и событий для освещения актуальной юридической
          информации
        </p>
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Задачи</p>
      </div>
      <div class="box_main_info_project_right">
        <ul class="list_articles subtext_services_design">
          <li>
            Разработать уникальный строгий дизайн, подчеркивающий надежность и
            профессионализм
          </li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>
            Реализовать многоуровневую систему анимаций, обеспечивающую
            интерактивность
          </li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>
            Создать разделы для портфолио, команды, услуг и юридических новостей
          </li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>
            Интегрировать административную панель для удобного управления
            контентом
          </li>
        </ul>
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Решение</p>
      </div>
      <div class="box_main_info_project_right">
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">01</p>
          <p class="subtext_services_design">
            <span class="fatty_font"
              >Разработка дизайна, подчеркивающего статус компании</span
            >
            <BR />
            &nbsp;
            <BR />
            Дизайнер Валерия разработала концепцию строгого и элегантного
            интерфейса с использованием:
            <BR />
            &nbsp;
            <BR />
            Минималистичных цветовых решений (глубокие темные тона, белый и
            золотой акценты)
            <BR />
            &nbsp;
            <BR />
            Четкой иерархии информации, удобной для восприятия
            <BR />
            &nbsp;
            <BR />
            Лаконичной типографики, соответствующей корпоративному стилю
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">02</p>
          <p class="subtext_services_design">
            <span class="fatty_font"
              >Реализация сложных анимаций и интерактивных элементов</span
            >
            <BR />
            &nbsp;
            <BR />
            Анимация при прокрутке для создания плавного эффекта переходов между
            секциями
            <BR />
            &nbsp;
            <BR />
            Hover-эффекты на карточках услуг и членов команды для интерактивного
            взаимодействия
            <BR />
            &nbsp;
            <BR />
            Динамическая загрузка контента без перезагрузки страницы для
            удобства пользователей
          </p>
        </div>
      </div>
    </div>
    <div class="container_slaider_project">
      <button class="custom-prev">
        <img
          class="arrow_left_slider"
          src="@/assets/elements/arrow_right.svg"
          alt="стрелка"
        />
      </button>

      <button class="custom-next">
        <img
          class="arrow_right_slider"
          src="@/assets/elements/arrow_right.svg"
          alt="стрелка"
        />
      </button>
      <swiper
        :modules="modules"
        :slides-per-view="1"
        loop="true"
        class="mySwiper"
        :navigation="{
          nextEl: '.custom-next',
          prevEl: '.custom-prev',
        }"
      >
        <swiper-slide v-for="(slide, index) in slides" :key="index">
          <img :src="slide" class="slide-content" alt="слайд проекта" />
        </swiper-slide>
      </swiper>
    </div>

    <div class="container_main_info_project">
      <div class="box_main_info_project_left"></div>
      <div class="box_main_info_project_right">
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">03</p>
          <p class="subtext_services_design">
            <span class="fatty_font"
              >Раздел «Портфолио» с кейсами юридической практики</span
            >
            <BR />
            &nbsp;
            <BR />
            Добавлена система фильтрации по направлениям
            <BR />
            &nbsp;
            <BR />
            Каждое дело представлено в формате краткого описания + детального
            разбора
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">04</p>
          <p class="subtext_services_design">
            <span class="fatty_font"
              >Страница «Команда» с индивидуальными карточками юристов</span
            >
            <BR />
            &nbsp;
            <BR />
            Информация о каждом специалисте: опыт, специализация, достижения
            <BR />
            &nbsp;
            <BR />
            Динамическое отображение кейсов, в которых участвовал специалист
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">05</p>
          <p class="subtext_services_design">
            <span class="fatty_font">
              Информационный раздел с юридическими новостями и событиями</span
            >
            <BR />
            &nbsp;
            <BR />
            Возможность публиковать актуальные материалы о законодательных
            изменениях
            <BR />
            &nbsp;
            <BR />
            Внедрена система подписки на обновления
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">06</p>
          <p class="subtext_services_design">
            <span class="fatty_font"
              >Административная панель для управления контентом</span
            >
            <BR />
            &nbsp;
            <BR />
            Простая система редактирования для добавления новых кейсов и статей
            <BR />
            &nbsp;
            <BR />
            Гибкое управление разделами сайта без необходимости привлечения
            разработчиков
          </p>
        </div>
      </div>
    </div>

    <swiper
      :modules="modules"
      :slides-per-view="slidesPerView"
      loop="true"
      class="mySwiper_2"
    >
      <swiper-slide v-for="(slides_2, index) in slides_2" :key="index">
        <img :src="slides_2" class="simg_project" alt="слайд проекта" />
      </swiper-slide>
    </swiper>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Результат</p>
      </div>
      <div class="box_main_info_project_right">
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Презентабельный корпоративный сайт, подчеркивающий надежность
            юридической фирмы
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Интерактивный пользовательский опыт благодаря современным анимациям
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Структурированное представление услуг, портфолио и информации о
            команде
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Удобная CMS для самостоятельного управления контентом
          </p>
        </div>
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Команда</p>
      </div>
      <div class="box_main_info_project_right_row">
        <ul class="ul_team subtext_services_design">
          <span class="color_violet">Команда</span>
          <li>UX/UI дизайн: Стрельцова Валерия</li>
          <li>Backend-разработка: Ражев Дмитрий</li>
          <li>Frontend-разработка: Немчицкий Кирилл</li>
          <li>DevOps: Кошелев Ростислав</li>
        </ul>
      </div>
    </div>
  </section>
  <SectionBlog />
  <SectionProjects />
  <FooterPages />
</template>
<script>
import { useHead } from "@vueuse/head";
import { ref, onMounted } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import HeaderPages from "../permanent/HeaderPages.vue";
import FooterPages from "../permanent/FooterPages.vue";
import SectionBlog from "../ui/SectionBlog.vue";
import SectionProjects from "../ui/SectionProjects.vue";
import slide_1 from "@/assets/project/Vatamanuk/Vatamanuk_slide_1.webp";
import slide_2 from "@/assets/project/Vatamanuk/Vatamanuk_slide_2.webp";
import slide_3 from "@/assets/project/Vatamanuk/Vatamanuk_slide_3.webp";
import slide_4 from "@/assets/project/Vatamanuk/Vatamanuk_slide_4.webp";

import slide_1_m from "@/assets/project/Vatamanuk/Vatamanuk_slide_1_m.webp";
import slide_2_m from "@/assets/project/Vatamanuk/Vatamanuk_slide_2_m.webp";
import slide_3_m from "@/assets/project/Vatamanuk/Vatamanuk_slide_3_m.webp";

export default {
  components: {
    Swiper,
    SwiperSlide,
    HeaderPages,
    FooterPages,
    SectionBlog,
    SectionProjects,
  },

  setup() {
    useHead({
      title:
        "Корпоративный сайт для юридической компании «Ватаманюк & Партнеры» – Дизайн, разработка, анимация",
      meta: [
        {
          name: "description",
          content:
            "Разработка корпоративного сайта для юридической компании «Ватаманюк & Партнеры». Уникальный UX/UI-дизайн, интерактивные элементы, портфолио кейсов и команда юристов. Современный подход к представлению юридических услуг в цифровой среде.",
        },
      ],
    });
    const slides = [slide_1, slide_2, slide_3, slide_4];
    const slides_2 = [slide_1_m, slide_2_m, slide_3_m];

    const slidesPerView = ref(3);

    const updateSlidesPerView = () => {
      if (window.innerWidth <= 767) {
        slidesPerView.value = 2;
      } else {
        slidesPerView.value = 3;
      }
    };
    onMounted(() => {
      updateSlidesPerView();
      window.addEventListener("resize", updateSlidesPerView);
    });
    return {
      slides,
      slides_2,
      updateSlidesPerView,
      slidesPerView,
      modules: [Navigation],
    };
  },
};
</script>
<style scoped>
.container_main_info_project {
  height: fit-content;
}
.section_main_info_project {
  gap: 2.5rem;
}
.title_home_4 {
  color: rgb(255, 255, 255);
}
.section_header_full_pages {
  background: linear-gradient(
    -22.83deg,
    rgb(28, 29, 38) 19.752%,
    rgb(58, 61, 84) 101.537%
  );
}
.img_brand_project {
  width: 20.9rem;
  height: 19.05rem;
}
.box_img_brand_project {
  position: absolute;
  right: 3rem;
  top: 6rem;
}
.simg_project {
  height: 37rem;
  border-radius: 1.7rem;
  box-shadow: 0.7rem 0.7rem 2rem -0.8rem rgba(71, 86, 163, 0.4);
  background: rgb(245, 247, 255);
}
.fatty_font {
  font-family: Kreadon-Bold !important;
}
.mySwiper_2 {
  padding-bottom: 4rem;
}
@media (max-width: 767px) {
  .container_text_full_pages {
    padding: 11rem 2rem 4.5rem 2rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .section_header_full_pages {
    height: 51.36rem;
  }
  .title_home {
    z-index: 0;
  }
  .img_brand_project {
    width: 22.45rem;
    height: 20.91rem;
  }
  .box_img_brand_project {
    position: absolute;
    right: 2rem;
    top: 19rem;
  }
  .simg_project {
    height: 28rem;
    box-shadow: 1.27rem 1.27rem 3.64rem -1.45rem rgba(71, 86, 163, 0.4);
  }
  .mySwiper_2 {
    padding-left: 1.5rem;
    padding-bottom: 4rem;
  }
  .container_main_info_project {
    flex-direction: column;
  }
  .ul_team .color_violet {
    display: none;
  }
  .font_1_400_Kreadon_Regular {
    line-height: 1.27rem;
  }
  .container_slaider_project {
    margin: 0rem;
  }
}
</style>
